import { client } from "api";
import { Order } from "models/Order";

export type GetOrderRequest = string;

export type GetOrderResponse = Order;

export const getOrder = (orderId: GetOrderRequest) =>
  client.get<GetOrderResponse>(`/order/${orderId}`).then((res) => res.data);
